import {configureStore, getDefaultMiddleware} from '@reduxjs/toolkit';
import logger from 'redux-logger';
import rootReducer from './reducers/rootReducer';

import {
  persistStore,
  persistReducer
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { listenerMiddleware } from '@app/store/listeners';

// 1) Cấu hình persist: chỉ lưu apiRoleMapping
const persistConfig = {
  key: 'root',            // bạn có thể đổi thành 'apiRoleMapping' nhưng thường dùng 'root'
  storage,
  whitelist: ['apiRoleMapping', 'account'], // lưu cả account để giữ thông tin khi reload
};

// 2) Bọc rootReducer vào persistedReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    // reducer: rootReducer,
    reducer: persistedReducer,
    middleware: getDefaultMiddleware({
        thunk: true,
        // cần tắt kiểm tra serializable với redux-persist
        serializableCheck: false
    }).prepend(listenerMiddleware.middleware).concat(logger)
    // middleware: [thunk,logger]
});

export const persistor = persistStore(store);

export default store;


// // store.js
// import { configureStore } from '@reduxjs/toolkit';
// import logger from 'redux-logger';
// import rootReducer from './reducers/rootReducer';

// import {
//   persistStore, persistReducer,
//   FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER
// } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';

// import { listenerMiddleware, setupListeners } from '@app/store/listeners';

// const persistConfig = { key: 'root', storage, whitelist: ['apiRoleMapping'] };
// const persistedReducer = persistReducer(persistConfig, rootReducer);

// console.log('[store] creating...');
// export const store = configureStore({
//   reducer: persistedReducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       thunk: true,
//       serializableCheck: { ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER] }
//     })
//       .prepend(listenerMiddleware.middleware)
//       .concat(logger)
// });

// export const persistor = persistStore(store);
// console.log('[store] persistor ready');

// setupListeners({
//   startListening: listenerMiddleware.startListening,
//   purgePersist: async () => { await persistor.flush(); await persistor.purge(); }
// });
// console.log('[store] listeners wired');

// export default store;

